(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["wi-product-awards"] && !Shopify.designMode) return;
  try {
    class WIProductAwards extends HTMLElement {
    data = [];
    constructor() {
      super();
    }

    connectedCallback() {
      const dataEl = this.querySelector('script');
      if (!dataEl) {
        console.error('No accolades data element found.');
        return;
      }
      try {
        this.data = JSON.parse(dataEl.textContent);
        console.log(this.data);
      } catch (e) {
        console.error('JSON parse failed for accolades data', e);
        return;
      }

      const templateEl = this.querySelector('template');
      if (!templateEl) {
        console.error('No template element found');
        return;
      }

      const listEl = this.querySelector('[data-list]');
      if (!listEl) {
        console.error('List container data-list element not found');
        return;
      }

      const listItems = this.data.map((item) => {
        const itemTpl = templateEl.content.cloneNode(true);
        if (item.medal && item.medal !== '') {
          itemTpl.querySelector('[data-medal]').textContent = item.medal;
        }
        if (item.point_range_low && item.point_range_low !== '') {
          itemTpl.querySelector('[data-points]').textContent = `${item.point_range_low} PTS`;
        }
        if (item.title && item.title !== '') {
          itemTpl.querySelector('[data-title]').textContent = `${item.award_year} ${item.title}`;
        }
        return itemTpl;
      });

      listEl.innerHTML = '';
      listEl.append(...listItems);
    }

    disconnectedCallback() {}
  }
  if (!customElements.get('wi-product-awards')) {
    customElements.define('wi-product-awards', WIProductAwards);
  }
  } catch(e) { console.error(e); }
})();

})();
